var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ItemSize"},[_vm._v(" "+_vm._s(_vm.shortSize)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }